export default "https://cdn-static.gokick.com/assets/9232f824e6a46c896411df64bf74cb68df4bd809/images/sleep-green-apple.f225c952c3b7c02c96ff4f722551ea5d.png";